import { axiosAuth } from "./axiosApi";
import { API_PATHS } from "./constants";

export const messagesList = async () => axiosAuth.get(API_PATHS.MESSAGES_LIST);

export const conversationById = async (id) =>
  axiosAuth.get(`${API_PATHS.MESSAGES_LIST}/${id}/messages`);

export const sendMessage = async (id, data) =>
  axiosAuth.post(
    `${API_PATHS.MESSAGES_LIST}/${id}${API_PATHS.MESSAGES_SEND}/`,
    data
  );
